module.exports = __webpack_public_path__ + "static/Mindblown-Small-5ebc95c8ee9d2451a9bd04a058b711f2.png";